import React from "react";
import { Link } from "react-router-dom";

const Story: React.FC = () => (
  <section className="centered-section" style={{ textAlign: 'center' }}>
    <div className="translucent-box">
      <h2 className="main-heading">The Golden Edge Story</h2>
      <p className="story-paragraph">
        My name is John Golden. I was born in the Texas Panhandle, in a little town called Tulia. My dad was both a farmer and a rancher, so I grew up working around animals. I’ve carried a pocket knife since I was eight years old. Back then it was never a trophy, ornament, or weapon—it was a tool. I used it to open feed bags, cut baling twine, and take care of everyday chores.
      </p>
      <p className="story-paragraph">
        I remember watching my dad sharpen his knife with a round whetstone. He would hold the stone in the palm of his hand, spit on it, and sharpen in a circular motion. That’s where my lifelong sharpening journey began. You can’t master an art or perfect a craft in a single day—it takes years of practice and patience.
      </p>
      <p className="story-paragraph">
        I still keep one of those old round stones for nostalgia, but today I use a professional sharpening system with Japanese waterstones. If you’ve never had a knife professionally sharpened, you should give it a try. There’s nothing quite like the feel of a properly sharpened cutting edge. In fact, a dull knife is more dangerous than a sharp one—it takes more pressure than necessary and can slip more easily.
      </p>
      <h3 className="sub-heading">The Golden Edge</h3>
      <p className="story-paragraph">
        The Golden Edge is a one-man operation. Every knife is sharpened by me, by hand. For blades that are damaged or have been neglected too long, I use a custom belt grinder that I designed and built myself—a project 30 years in the making. The grinder isn’t for sharpening; it’s for re-profiling a blade back into proper shape. Once the edge is restored, the real sharpening begins. Every knife is finished by hand with Japanese waterstones and a magnifying glass. This ensures that every edge leaves my hands sharpened to absolute precision.
      </p>
      <p className="story-paragraph">
        My goal is simple: to deliver the best possible edge you’ll ever use.
      </p>
      <p style={{ marginTop: '2rem' }}>
  <Link to="/" className="main-link">&larr; Back to Main Page</Link>
      </p>
    </div>
  </section>
);

export default Story;
